module.exports = __webpack_public_path__ + "img/title.44be9940.png";